class StickyAtc extends HTMLElement {
  constructor() {
    super();

    if (!this.closest("body")) return;
    this.anchor = this.closest("body").querySelector(".main-product");
    this.button = this.querySelector("button add-to-cart");
  }

  connectedCallback() {
    this.scrollObserver();
  }

  scrollObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.isIntersecting ? this.hideButton() : this.showButton();
      });
    });

    observer.observe(this.anchor);
  }

  setHeight() {
    const stickyHeader = document.querySelector("sticky-header");
    const stickyHeaderHeight = stickyHeader.offsetHeight;

    this.style.setProperty("--sticky-header-height", `${stickyHeaderHeight}px`);
  }

  hideButton() {
    clearTimeout(this.showTimeout);
    this.classList.remove("is-visible");
  }

  showButton() {
    this.showTimeout = setTimeout(() => {
      this.setHeight();
      window.requestAnimationFrame(() => {
        this.classList.add("is-visible");
      });
    }, 300);
  }
}

if (!customElements.get("sticky-atc")) {
  customElements.define("sticky-atc", StickyAtc);
}
